import { Badge } from '@mantine/core';
import FormattedRecordTimestamp from '../../../utils/FormattedRecordTimestamp';
import { Alias } from '../../aliases/types';
import { AliasStatusToggleButton } from '../components/AliasStatusToggleButton';

export const useAliasesTableColumns = () => {
    return [
        { accessor: 'name', title: 'Name' },
        { accessor: 'aliasType', title: 'Type', render: (row: Alias) => (
            <Badge color={row.aliasType === 'USER' ? 'blue' : 'gray'}>{row.aliasType}</Badge>
        )},
        { accessor: 'aliasStatus', title: 'Status', render: (row: Alias) => (
            <Badge color={row.aliasStatus === 'ENABLED' ? 'green' : 'red'}>{row.aliasStatus}</Badge>
        )},
        { accessor: 'createdFromPersona', title: 'From Persona', render: (row: Alias) => row.createdFromPersona ? 'Yes' : 'No' },
        { accessor: 'createdByUsername', title: 'Owner' },
        { accessor: 'created', title: 'Created', render: (row: Alias) => (
            <FormattedRecordTimestamp record={row} propertyName="created" />
        )},
        { accessor: 'actions', title: 'Actions', render: (row: Alias) => <AliasStatusToggleButton alias={row} /> }
    ];
};
